var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"chat-rich",class:{ compact: _vm.compact }},_vm._l((_vm.parts),function(part,index){return _c('span',{key:index},[(part.type === 'emoji')?_c('img',{staticClass:"chat-rich-emoji",attrs:{"src":part.src,"alt":"表情","draggable":"false"}}):[_vm._v(_vm._s(part.text))]],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }